// extracted by mini-css-extract-plugin
module.exports = {"sliderColor":"ClassSizeSlider_sliderColor__LIqgW","sliderLabel":"ClassSizeSlider_sliderLabel__2BIY5"};